module.exports = __webpack_public_path__ + "static/media/dorp.dce9914d.jpg";